module.exports = __webpack_public_path__ + "static/img/1.fc2d485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/1.png
// module id = Ayz+
// module chunks = 3